import { useQuery } from "@tanstack/react-query";
import { publicApi } from "@/lib/api";
import { useContent } from "@/lib/content";

export default function Privacy() {
  const { data: s = {} } = useQuery({ queryKey: ["settings"], queryFn: async () => (await publicApi.get("/settings")).data });
  const { t } = useContent();
  const email = s.contact_email || "hello@ideaeventsusa.com";
  const sections = [
    ["privacy.collect_h", "privacy.collect_b"],
    ["privacy.use_h", "privacy.use_b"],
    ["privacy.pay_h", "privacy.pay_b"],
    ["privacy.cookies_h", "privacy.cookies_b"],
    ["privacy.choices_h", "privacy.choices_b"],
  ];
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="privacy-page">
      <p className="overline-label mb-2">Legal</p>
      <h1 className="font-serif text-4xl lg:text-5xl text-cream mb-8">{t("privacy.title")}</h1>
      <div className="space-y-6 text-muted2 leading-relaxed">
        <p>{t("privacy.intro")}</p>
        {sections.map(([h, b]) => (
          <div key={h}>
            <h2 className="font-serif text-xl text-cream mb-2">{t(h)}</h2>
            <p>{t(b)}</p>
          </div>
        ))}
        <div>
          <h2 className="font-serif text-xl text-cream mb-2">Contact</h2>
          <p>Questions about this policy? Email <a className="text-gold hover:text-gold-bright" href={`mailto:${email}`}>{email}</a>.</p>
        </div>
        <p className="text-xs text-muted2/70">Last updated: {new Date().getFullYear()}.</p>
      </div>
    </div>
  );
}
